import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { ItemResultProps, LocationResponse, MarkerType } from './types';

export const mapLocationsToMarkers = (
  locations: LocationResponse[],
): MarkerType[] => {
  return locations.map((location: LocationResponse, index: number) => ({
    icon: get(AssuranceIcon, location.type),
    id: index,
    position: {
      lat: +location.latitude,
      lng: +location.longitude,
    },
  }));
};

export const mapLocationsToItemResults = (
  locations: LocationResponse[],
): ItemResultProps[] => {
  return locations.map((location: LocationResponse, index: number) => ({
    title: location.raison_sociale,
    subTitle: location.adresse,
    id: index,
    ...location,
  }));
};

export const mapDoctorsToMarkers = (doctors: any[]): MarkerType[] =>
  doctors.map(({ location }, index: number) => ({
    icon: AssuranceIcon.point_de_depot,
    id: index,
    position: {
      lat: +location.latitude,
      lng: +location.longitude,
    },
  }));
